// Unified filter options matching profile values
export const FILTER_OPTIONS = {
  // Height categories (matching profile options)
  height: [
    'abaixo_150',
    '150_155',
    '156_160',
    '161_165',
    '166_170',
    '171_175',
    '176_180',
    '181_185',
    '186_190',
    '191_195',
    '196_200',
    'acima_200',
    'prefiro_nao_dizer'
  ],

  // Body type (matching profile options)
  bodyType: [
    'magro',
    'atletico',
    'medio',
    'curvilíneo',
    'musculoso',
    'plus_size',
    'prefiro_nao_dizer'
  ],

  // Marital status (matching profile options)
  maritalStatus: [
    'solteiro',
    'casado',
    'divorciado',
    'viuvo',
    'comprometido',
    'relacionamento_aberto',
    'prefiro_nao_dizer'
  ],

  // Smoker (matching profile options)
  smoker: [
    'nao',
    'socialmente',
    'ocasionalmente',
    'regularmente',
    'prefiro_nao_dizer'
  ],

  // Drinks (matching profile options)
  drinker: [
    'nao',
    'raramente',
    'socialmente',
    'regularmente',
    'prefiro_nao_dizer'
  ],

  // Tattoos (matching profile values)
  tattoos: [
    'Não',
    'Sim',
    'Tenho discretas',
    'Prefiro não dizer'
  ],

  // Piercings (matching profile values)
  piercings: [
    'Não',
    'Sim',
    'Tenho discretos',
    'Prefiro não dizer'
  ],

  // Eye color (matching profile options)
  eyeColor: [
    'castanhos',
    'pretos',
    'azuis',
    'verdes',
    'mel',
    'cinza',
    'avela',
    'outros'
  ],

  // Hair color (matching profile options)
  hairColor: [
    'preto',
    'castanho_escuro',
    'castanho_claro',
    'loiro_escuro',
    'loiro_claro',
    'ruivo',
    'grisalho',
    'careca',
    'outros'
  ],

  // Children
  children: [
    'nao_tenho',
    '1',
    '2',
    '3',
    '4_ou_mais',
    'prefiro_nao_dizer'
  ],

  // Travel availability
  travelAvailability: [
    'nao',
    'somente_minha_cidade',
    'somente_meu_estado',
    'somente_meu_pais',
    'quero_viajar_mundo_todo'
  ],

  // Relationship type (from onboarding)
  relationshipType: [
    'serious',
    'casual_fixed',
    'casual_flex'
  ],

  // Sigilo presença
  sigilo_presenca: [
    'sim_comprometido',
    'nao_livre_relacoes',
    'prefiro_nao_dizer'
  ]
};

// Labels for display purposes
export const FILTER_LABELS = {
  height: {
    'abaixo_150': 'Abaixo de 1,50m',
    '150_155': '1,50m - 1,55m',
    '156_160': '1,56m - 1,60m',
    '161_165': '1,61m - 1,65m',
    '166_170': '1,66m - 1,70m',
    '171_175': '1,71m - 1,75m',
    '176_180': '1,76m - 1,80m',
    '181_185': '1,81m - 1,85m',
    '186_190': '1,86m - 1,90m',
    '191_195': '1,91m - 1,95m',
    '196_200': '1,96m - 2,00m',
    'acima_200': 'Acima de 2,00m',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  },
  bodyType: {
    'magro': 'Magro',
    'atletico': 'Atlético',
    'medio': 'Médio',
    'curvilíneo': 'Curvilíneo',
    'musculoso': 'Musculoso',
    'plus_size': 'Plus Size',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  },
  maritalStatus: {
    'solteiro': 'Solteiro(a)',
    'casado': 'Casado(a)',
    'divorciado': 'Divorciado(a)',
    'viuvo': 'Viúvo(a)',
    'comprometido': 'Comprometido(a)',
    'relacionamento_aberto': 'Relacionamento Aberto',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  },
  smoker: {
    'nao': 'Não',
    'socialmente': 'Socialmente',
    'ocasionalmente': 'Ocasionalmente',
    'regularmente': 'Regularmente',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  },
  drinker: {
    'nao': 'Não',
    'raramente': 'Raramente',
    'socialmente': 'Socialmente',
    'regularmente': 'Regularmente',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  },
  tattoos: {
    'Não': 'Não',
    'Sim': 'Sim',
    'Tenho discretas': 'Tenho discretas',
    'Prefiro não dizer': 'Prefiro não dizer'
  },
  piercings: {
    'Não': 'Não',
    'Sim': 'Sim',
    'Tenho discretos': 'Tenho discretos',
    'Prefiro não dizer': 'Prefiro não dizer'
  },
  eyeColor: {
    'castanhos': 'Castanhos',
    'pretos': 'Pretos',
    'azuis': 'Azuis',
    'verdes': 'Verdes',
    'mel': 'Mel',
    'cinza': 'Cinza',
    'avela': 'Avelã',
    'outros': 'Outros'
  },
  hairColor: {
    'preto': 'Preto',
    'castanho_escuro': 'Castanho Escuro',
    'castanho_claro': 'Castanho Claro',
    'loiro_escuro': 'Loiro Escuro',
    'loiro_claro': 'Loiro Claro',
    'ruivo': 'Ruivo',
    'grisalho': 'Grisalho',
    'careca': 'Careca',
    'outros': 'Outros'
  },
  children: {
    'nao_tenho': 'Não tenho filhos',
    '1': '1',
    '2': '2',
    '3': '3',
    '4_ou_mais': '4 ou mais',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  },
  travelAvailability: {
    'nao': 'Não',
    'somente_minha_cidade': 'Somente minha cidade',
    'somente_meu_estado': 'Somente meu estado',
    'somente_meu_pais': 'Somente meu país',
    'quero_viajar_mundo_todo': 'Quero viajar o mundo todo!'
  },
  relationshipType: {
    'serious': 'Relacionamento Sério',
    'casual_fixed': 'Caso Fixo',
    'casual_flex': 'Encontros'
  },
  sigilo_presenca: {
    'sim_comprometido': 'Sim, espero sigilo',
    'nao_livre_relacoes': 'Não, estou livre para relações abertas',
    'prefiro_nao_dizer': 'Prefiro não dizer'
  }
};
